<template>
    <card class="front"
        >
            <template v-slot:title>
                <slot name="title"></slot>
            </template>
        <v-container class="lang-HE front">
            <slot></slot>
        </v-container>
    </card>
</template>

<script>
    import Card from "@/components/Card";
    export default {
        name: "CardFront",
        components: {Card}
    }
</script>

<style>
</style>